<div class="fixed inset-0 bg-gray-700 bg-opacity-75 flex justify-center items-center z-20">
    <div class="bg-white shadow-lg rounded p-4 max-w-md w-full relative">
        <h1 class="font-bold text-xl">{{title}}</h1>

        <div class="flex flex-row bg-gray-50 border-l-4 border-red-500 mb-4 px-4 py-2 w-full mt-2">
            <div class="bg-red-100 rounded-full h-10 w-10 min-h-10 min-w-10 text-center grid content-center">
                <i class="fas fa-triangle-exclamation text-lg text-red-500 py-auto"></i>
            </div>
            <div class="flex flex-col text-xs ml-4 gap-1">
                <p class="text-red-500 block">Use this feature for un-registered AtChurch students only
                </p>
                <p class="text-primary-500">For students who are registered AtChurch users, kindly send an invite to
                    join the group
                </p>
            </div>
        </div>

        <p class="text-primary-300 text-sm">{{description}}</p>

        <form [formGroup]="pageForm" (ngSubmit)="submit()">
            <div class="mt-4 w-full flex flex-row justify-between">
                <div>
                    <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                        First Name *
                    </label>
                    <input type="text" formControlName="firstName" name="firstName"
                        class="rounded my-auto outline-none w-full ring-0 focus:outline-none focus:ring-0 placeholder-blueGray-300 text-blueGray-600">
                    <div
                        class="{{ pageForm.get('firstName')?.invalid && (pageForm.get('firstName')?.dirty || pageForm.get('firstName')?.touched) ? 'visible' : 'invisible'}}  pt-1 h-6 text-red-500 text-xs">
                        @if(pageForm.get('firstName')?.errors?.['required']){
                        <p>
                            Value is required
                        </p>
                        } @else if (pageForm.get('firstName')?.errors?.['pattern'])
                        {
                        <p>
                            Only letters allowed
                        </p>
                        } @else if (pageForm.get('firstName')?.errors?.['minlength'] ||
                        pageForm.get('firstName')?.errors?.['maxlength'])
                        {
                        <p>
                            Min {{ pageForm.get('firstName')?.errors?.['minlength']?.requiredLength }} and max {{
                            pageForm.get('firstName')?.errors?.['maxlength']?.requiredLength }} chars
                        </p>
                        }
                    </div>
                </div>
                <div>
                    <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                        Surname *
                    </label>
                    <input type="text" formControlName="surname" name="surname"
                        class="rounded my-auto outline-none w-full ring-0 focus:outline-none focus:ring-0 placeholder-blueGray-300 text-blueGray-600">
                    <div
                        class="{{ pageForm.get('name')?.invalid && (pageForm.get('name')?.dirty || pageForm.get('name')?.touched) ? 'visible' : 'invisible'}}  pt-1 h-6 text-red-500 text-xs">
                        @if(pageForm.get('name')?.errors?.['required']){
                        <p>
                            Value is required
                        </p>
                        } @else if (pageForm.get('firstName')?.errors?.['pattern'])
                        {
                        <p>
                            Only letters allowed
                        </p>
                        } @else if (pageForm.get('name')?.errors?.['minlength'] ||
                        pageForm.get('name')?.errors?.['maxlength'])
                        {
                        <p>
                            Min {{ pageForm.get('surname')?.errors?.['minlength']?.requiredLength }} and max {{
                            pageForm.get('surname')?.errors?.['maxlength']?.requiredLength }} chars
                        </p>
                        }
                    </div>
                </div>
            </div>

            <div class="w-full mb-2">
                <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                    Emergency Contact
                </label>
                <app-contact formControlName="contact"></app-contact>
            </div>

            <div class="w-full mb-4">
                <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                    Grade
                </label>
                <select formControlName="gradeId"
                    class="border-0 px-2 py-2 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:ring-1 ring-1 outline-1 w-full ease-linear transition-all duration-150">
                    @for (item of grades; track item.id) {
                    <option [selected]="pageForm.get('gradeId')?.value == item.id" [value]="item.id">
                        {{item.gradeName}}</option>
                    }
                    <option selected="unassigned" value="unassigned">
                        Unassigned</option>
                </select>
            </div>
            <div class="flex flex-row gap-4 justify-end">
                <button type="button" (click)="onCancel()"
                    class="text-primary-500 px-4 py-2 focus:outline-none">Cancel</button>
                <app-btn-action (click)="submit()" [inProgress]="(working$ | async) ?? false" [label]="action"
                    bgColor="bg-primary-500 hover:bg-primary-300"></app-btn-action>
                <!-- <button type="submit"
                    class="bg-primary-500 disabled:bg-primary-100 disabled:text-primary-500 text-white rounded font-semibold px-4 py-2 focus:outline-none">{{action}}</button> -->
            </div>
        </form>
    </div>
</div>